module.exports = __webpack_public_path__ + "static/backlite-media-result-4-80f999ba3f331651cfe7a6d379d7f0bc.png";